<ng-container *ngIf="field.readonly === true">
  <crm-row>
    <header>{{ field.name }}</header>
    <main>{{ readonlyValue$ | async }}</main>
  </crm-row>
</ng-container>

<ng-container *ngIf="!field.readonly" [formGroup]="parentFormGroup">
  <mat-label class="radio-group-label">{{ field.name }}</mat-label>

  <mat-radio-group
    class="radio-group-field"
    [class.radio-group-field--column]="column"
    [formControlName]="field.key"
    [required]="parentFormGroup.get(field.key).errors?.required"
    [disabled]="disabled"
  >
    <mat-radio-button *ngFor="let option of options$ | async" color="primary" [value]="option.value">
      {{ option.label }}
    </mat-radio-button>
  </mat-radio-group>
</ng-container>
